import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
} from "@material-ui/core";
import Link from "@material-ui/core/Link";
import { NavLink } from "react-router-dom";
import { spacing } from "@material-ui/system";

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 64px - 48px - 106px - 48px - 64px);
  position: relative;
`;

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const MonthlyAugReport = () => {
  return (
    <>
      <Helmet title="Monthly Aug Report" />
      <Typography variant="h3" gutterBottom display="inline">
        Monthly Aug Report
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/dashboard">
          Dashboard
        </Link>
        <Typography>Monthly Aug Report</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <Container>
        <iframe
          src="https://docs.google.com/spreadsheets/d/1glWbiTUJliQtmbGebkvvHovCSbwGooNLXf-bDvocvy0/edit?usp=sharing&rm=minimal&headers=false&widget=false&single=false&chrome=false&"
          width="100%"
          height="100%"
          frameBorder="0"
          scrolling="no"
          title="Monthly Aug Report"
        />
      </Container>
    </>
  );
};

export default MonthlyAugReport;
